(() => {
  const init = root => {
    root.querySelectorAll?.('[data-s7-glow]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';
      const img = section.querySelector('[data-glow-main]');
      const tabs = [...section.querySelectorAll('[data-glow-tab]')];
      const title = section.querySelector('[data-glow-title]');
      const copy = section.querySelector('[data-glow-copy]');
      const counter = section.querySelector('[data-glow-counter]');
      const zones = [...section.querySelectorAll('[data-zone]')];

      function setMode(btn, index) {
        tabs.forEach((t,i) => {
          t.classList.toggle('is-active', t === btn);
          t.setAttribute('aria-selected', t === btn ? 'true' : 'false');
        });
        if (img && btn.dataset.image) {
          img.classList.add('is-changing');
          setTimeout(() => {
            img.src = btn.dataset.image;
            img.classList.remove('is-changing');
          }, 130);
        }
        title.textContent = btn.dataset.title || '';
        copy.textContent = btn.dataset.copy || '';
        counter.textContent = String(index + 1).padStart(2,'0') + ' / 04';
        const mode = btn.dataset.mode;
        zones.forEach(zone => {
          const on = mode === 'all' || zone.dataset.zone === mode;
          zone.classList.toggle('is-on', on);
          zone.querySelector('em').textContent = on ? 'ON' : 'OFF';
        });
      }
      tabs.forEach((btn,i) => btn.addEventListener('click', () => setMode(btn,i)));
    });
  };
  if (window.__ISWS7Glow) {
    window.__ISWS7Glow.init(document);
    return;
  }

  window.__ISWS7Glow = { init };

  const boot = () => window.__ISWS7Glow.init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Motion lifecycle event: theme assets are fully ready.
  document.addEventListener('page:loaded', boot);

  // Shopify Theme Editor section reload.
  document.addEventListener('shopify:section:load', e => {
    window.__ISWS7Glow.init(e.target);
  });
})();